import '../../stylesheets/ArticleListSS.css'
import icon from "../../images/icons/angle-circle-right.svg"
import { Link } from 'react-router-dom';

function ArticleList({ data, filter, update }) {

    //Filtering for articles that match the users input, if undefined, no input has been given, meaning true, otherwise we compare

    let filterList = [];
    let dFilter = (filter.Date === undefined) ? true : false;
    let tFilter = (filter.Topic === undefined) ? true : false;

    // eslint-disable-next-line
    filterList = data.filter((article) => {
        let dFlag = true;
        let tFlag = true;
        //date filter
        if (!dFilter) {
            dFlag = (new Date(article[1].Date).getDate() >= new Date(filter.Date).getDate()) ? true : false;
        }
        //topic filter
        if (!tFilter) {
            tFlag = (article[1].Topic.includes(filter.Topic)) ? true : false;
        }
        //return only the articles that are both true, e.g. one undefined and a matching filter.
        if (dFlag && tFlag) {
            return article
        }
    }
    )

    function filterUpdate(e) {
        //getting topic of selected item and using it to filter
        let topic = e.currentTarget.innerHTML.substring(2);
        update(topic);
    }

    //Checking if any records match the filter
    if (filterList.length === 0) {
        return (
            <span id='no_rec'>
                No records for the selected filter
            </span>
        )
    }

    //returning an ol of list items for each record
    return (
        <div id='list'>
            <section>
                <ol>
                    {filterList.map((article, index) => {
                        return (
                            <div className='article_wrapper' key={index}>
                                <Link key={index} to={`/articles/${article[0]}`} state={article} className='articleLink'>
                                    <li className='article' key={article[0]}>
                                        <div id='icon_container'>
                                            <span id='icon'><img src={icon} alt='ArrowIcon'></img></span>
                                        </div>
                                        <div id='text_container'>
                                            <div id='r1'>
                                                <h3>
                                                    {article[1].Title}:
                                                </h3>
                                                <time>
                                                    {'\t'}{article[1].Date}
                                                </time>
                                                <span id='author_text'>
                                                    {article[1].Author}
                                                </span>
                                            </div>
                                            <span id='intro_text'>
                                                {article[1].Text[0].text.substring(0, 80)}...<br></br>
                                            </span>

                                        </div>
                                    </li>
                                </Link>
                                <div id='topic_wrapper'>
                                    <div id='empty'></div>
                                    <span id='topics'>
                                        {article[1].Topic.map((topic, index) => {
                                            return (<button className='topic' key={index} onClick={filterUpdate}> #{topic.toLocaleLowerCase()}</button>)
                                        })}
                                    </span>
                                </div>

                            </div>
                        )

                    })}
                </ol>
            </section>
        </div>
    )
}

export default ArticleList